<div id="popup-ocorrencia" class="modal full" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
 data-backdrop="static" data-keyboard="false">
 <div class="bg-loading" *ngIf="loading"></div>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalPopoversLabel"> Ocorrência </h5>
        <img data-dismiss="modal" class='bt-fechar' src="assets/imgs/icon_bt-limpar_header.svg" (click)="pararConsultaMsg()" >
      </div>
      <div class="modal-body">
        <button [hidden]="true" id="btnIniciaConsultaMsg" (click)="iniciarConsultaMsg()"></button>
        <div class="row no-gutters overflow-custom"> 
              <div id="ocorrencia-chat">
                <aside class="info">
                  <section class="mb-zero">
                    <div class="wrap">
                      <div class="titulo">
                        <h1>Roteiro: {{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.roteiro }}</h1>
                        <p class="data-expedicao" title="Data de Expedição">{{ util.converteData(mainContainerService?.listOcorrenciasRoteiroStatus[0]?.DataLiberacao) | date:'dd/MM/yy | HH:mm' }}</p>
                      </div>
                      <div class="veiculo">
                        <p title="Veículo">{{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.cod_veiculo }} - {{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.veiculo }}</p>
                        
                        <p title="Motorista" class="mt-2  mb-1 titulo-mot-ajud"><span class="sub-titulo-mot-ajud">Motorista:</span> {{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.nome_motorista }}</p>
                        <p title="Telefone" class="mt-2  mb-1 titulo-mot-ajud"><span class="sub-titulo-mot-ajud">Telefone:</span> <a [href]="'https://api.whatsapp.com/send?phone=' + mainContainerService?.listOcorrenciasRoteiroStatus[0]?.InfoRota.DDD + mainContainerService?.listOcorrenciasRoteiroStatus[0]?.InfoRota.Telefone" target="_blank">{{mainContainerService?.listOcorrenciasRoteiroStatus[0]?.InfoRota.DDD}} {{mainContainerService?.listOcorrenciasRoteiroStatus[0]?.InfoRota.Telefone}}</a></p>
                        <div *ngFor="let ajudante of mainContainerService.ajudantes">
                          <p class="mb-1 titulo-mot-ajud"> <span class="sub-titulo-mot-ajud">Ajudante:</span> {{ ajudante.nomeAjudante }}</p>
                        </div>
                      </div>
                      <div id="box-pedidos">
                        <div class="info-pedidos">
                          <div class="ped-titulo" title="Distância">
                            <img src="assets/imgs/icon_header_distancia.svg">
                            <p class="pp-valor">{{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.Distancia }} Km</p>
                          </div>
                          <div class="valor" title="Valor Total">
                            <img src="assets/imgs/icon_header_pedidos.svg">
                            <p class="pp-valor">{{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.ValorPedido | currency:'BRL':true  }} </p>
                          </div>
                          <div class="peso" title="Peso">
                            <img src="assets/imgs/icon_header_peso.svg">
                            <p class="pp-valor"> {{ mainContainerService?.listOcorrenciasRoteiroStatus[0]?.Peso }} Kg </p>
                          </div>
                        </div>
                      </div>


                      <div class="status" [class.status-novo]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 1"
                           [class.status-analise]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 2"
                           [class.status-finalizado]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 3">
                        <i class="fa" [class.fa-frown-o]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 1"
                           [class.fa-meh-o]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 2"
                           [class.fa-smile-o]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 3"></i> 
                           <div class='text'>
                             <p class='title'>{{ mainContainerService?.ocorrenciaSelecionado[0]?.Status }}</p>
                             <p class="motivo-finalizacao">{{ mainContainerService?.ocorrenciaSelecionado[0]?.StatusFinalizacao }}</p>
                           </div>
                      </div>
                    </div>
                  </section>

                     <section class="mb-zero" *ngIf="popupConfigService.mostraBtnCompartilhar  &&  popupConfigService.chaveAcesso ">
                      <div class="wrap">                     
                          <div (click)="copiarAcomponhamento(popupConfigService.chaveAcesso)" class="d-content"> 
                              <app-text-link 
                                placement="bottom"
                                titulo="Copiar Link de Rastreio" icone='clipboard'                  
                              >
                              </app-text-link> 
                          </div>
                    </div>
                  </section>

                  <div>

                    <div class="row no-gutters" class="modal-body mt-0" *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.CodigoCliente != undefined"> 
                      <div id="ocorrencia-chat">
                        <aside class="info">
                          <section class="pb-0">
                            <div class="wrap">
                              <div class="titulo">

                                <div *ngIf="mainContainerService.loadingListaPedidosNotas" class="d-flex align-items-center info-table-ped-nf mb-2" ><img src='assets/imgs/loading2.gif' width="26px"> Consultando pedido(s)...</div>
                                <div *ngIf="mainContainerService.listaPedidosNotas?.length" class="table-responsive mb-2">
                                  <div class="d-flex flex-column info-ped-nf">
                                    <span>
                                      {{ mainContainerService.listaPedidosNotas.length > 1 ? 'Pedidos' : 'Pedido' }}:
                                      {{ mainContainerService.pedidosOcorrenciaAtual }}
                                    </span>

                                    <span>
                                      {{ mainContainerService.listaPedidosNotas.length > 1 ? 'Notas Fiscais' : 'Nota Fiscal' }}:
                                      {{ mainContainerService.notasOcorrenciaAtual }}
                                    </span>
                                  </div>
                        
                                </div>
                                <h1>  <i class="fa fa-map-marker fa-sm codigo" aria-hidden="true" ></i> {{ mainContainerService?.ocorrenciaSelecionado[0]?.Endereco }} - {{ mainContainerService?.ocorrenciaSelecionado[0]?.Numero }}
                               <br>{{ mainContainerService?.ocorrenciaSelecionado[0]?.Bairro }} - {{ mainContainerService?.ocorrenciaSelecionado[0]?.Cidade }}/{{ mainContainerService?.ocorrenciaSelecionado[0]?.UF }}
                                <br>CEP: {{ mainContainerService?.ocorrenciaSelecionado[0]?.Cep.toString().substr(0,5) }}-{{ mainContainerService?.ocorrenciaSelecionado[0]?.Cep.toString().substr(5,8) }}
                                </h1>
                              </div>                      
                            </div>
                          </section>
                        </aside>  
                      </div>    
                    </div> 

                    <div class="row no-gutters" class="modal-body mt-0" *ngIf="mainContainerService.listaOcorrenciaLogs.length > 0"> 
                      <div id="ocorrencia-chat">
                        <aside class="info">
                          <section> 
                            <div class="wrap">
                              <div class="titulo">
                                <h1> <i class="fa fa-info-circle fa-sm codigo" aria-hidden="true" ></i> Histórico de andamentos</h1>
                              </div> 
                              <div class="veiculo border-log" *ngFor="let item of mainContainerService.listaOcorrenciaLogs">
                                <p>Usuário: <span class="titulo-log"> {{ item.Usuario }} </span> </p>
                                <p>Alterado para: <span class="titulo-log">{{ item.IdStatus == 2? 'Em Análise': 'Finalizada' }}</span></p>
                                <p>Data: <span class="titulo-log"> {{ item.Data.replace("Z", '') | date: 'dd/MM/yyyy HH:mm' }}</span></p>
                              </div>
                            </div>
                          </section>
                        </aside>  
                      </div>    
                    </div>

                  </div>

                  <footer id="aside-acao" >
                    <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 2" >
                      <div class="confirmacao">
                        <p>Confirma o encerramento desta ocorrência?</p>
                        <select name="statusFinalizacao" id="statusFinalizacao" (ngModelChange)="onChangeObj($event)" [(ngModel)]="popupOcorrenciaService.statusFinalizacaoSelecionado">
                          <option selected disabled>Selecionar Motivo</option>
                          <option *ngFor="let status of popupConfigService.vetListaStatusFinalizacao, let i = index" [value]="status?.IdStatusFinalizacao">{{ status?.Descricao }}</option>
                        </select>
                        <label class="lblValidacao" for="" *ngIf="msgValidacao !== '' " >{{ msgValidacao }}</label>
                        <footer>
                          <button class="btn nao" (click)="CancelarFinalizacao()">Não</button>
                          <button class="btn btn-primary sim" (click)="finalizacaoOcorrencia($event)">Sim</button>
                        </footer>
                      </div>
                      <button id="ocorrencia-finalizar" class="btn btn-primary btn-block" (click)="ConfirmarFinalizacao($event)"><i class="fa fa-arrow-circle-o-down"></i> Finalizar Ocorrência </button>
                    </div>
                    <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 1">
                      <button  class="btn btn-info btn-block" (click)="fecharVisualizacaoOcorrencia()"  > <i class="fa fa-arrow-circle-o-down"></i> Alterar para <b>Em Análise </b></button>                
                    </div>
                  </footer>
                </aside>
                <section class="chat">
                  <div class="header-char">
                    <header>
                      <img [class.status-novo]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 1" 
                          [class.status-analise]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 2" 
                          [class.status-finalizado]="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 3" class="icone" 
                          [src]="mainContainerService?.ocorrenciaSelecionado[0]?.CodigoCliente == null ? 'assets/imgs/rotaplan-gps-acao-problema-veiculo.svg' : 'assets/imgs/rotaplan-gps-acao-problema-cliente.svg'">
                      <div>
                          <h3>{{ mainContainerService?.ocorrenciaSelecionado[0]?.Motivo }} <span class="codigo"><i class="fa fa-tag"></i> {{ mainContainerService?.ocorrenciaSelecionado[0]?.CodigoOcorrencia }} </span></h3>
                          <p> <span class="nome-fantasia" *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.NomeFantasia"><i class="fa fa-home"></i> {{mainContainerService?.ocorrenciaSelecionado[0]?.RazaoSocial }} - {{ mainContainerService?.ocorrenciaSelecionado[0]?.NomeFantasia }} ({{ mainContainerService?.ocorrenciaSelecionado[0]?.CodigoCliente }}) </span> </p>
                          <p class="ml-1"> <span class="nome-fantasia" *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.NomeFantasia">{{mainContainerService?.ocorrenciaSelecionado[0]?.CnpjCpf | cpfcnpj }}   <i class="mr-4"></i>         {{ util.converteData(mainContainerService?.ocorrenciaSelecionado[0]?.Data) | date: 'dd/MM/yyyy | HH:mm' }}</span></p>
                      </div>
                    </header>
                    <button type="button" [disabled]="popupOcorrenciaService.loadingMsg" class="btn-atualizar-mensagem m-3" (click)="atualizarMensagens()">Atualizar mensagens</button>
                  </div>                  
        
                  <section id='chat-conteudo' class="timeline">
                    <div *ngIf="popupOcorrenciaService.loadingMsg" class="loading-msg">
                      <img src="assets/imgs/loading2.gif" alt="loading" class="img-loading">
                      Carregando           
                    </div>

                    <!-- Saneamento -->
                    <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.TipoEspecial == tipoOcorrenciaEspecial.SANEAMENTO_CLIENTE && mainContainerService?.ocorrenciaSelecionado[0]?.especial == true" class="msg">
                      <h5 class='nome'> {{  mainContainerService.descricaoMotoAjudante  }}
                        <span class='data'>{{ util.converteData(mainContainerService?.ocorrenciaSelecionado[0]?.Data) | date:'dd/MM/yy | HH:mm'  }}</span>
                      </h5>
                      <div  class="texto">
                        <div class="cliente d-flex">
                          <p class="cliente-endereco mr-1 mb-0">Cliente:</p>
                          <p class="propriedade-cliente">{{ mainContainerService?.ocorrenciaSelecionado[0].configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia? mainContainerService?.ocorrenciaSelecionado[0]?.NomeFantasia : mainContainerService?.ocorrenciaSelecionado[0]?.RazaoSocial}}</p>
                        </div>
                        <div class="endereco d-flex">
                          <p class="cliente-endereco mr-1">Endereço:</p>
                          <div class="propriedade-cliente d-flex">
                            <p>{{mainContainerService?.ocorrenciaSelecionado[0]?.Endereco}}, {{mainContainerService?.ocorrenciaSelecionado[0]?.Numero}} - {{mainContainerService?.ocorrenciaSelecionado[0]?.Bairro}}, {{mainContainerService?.ocorrenciaSelecionado[0]?.Cidade}} - {{mainContainerService?.ocorrenciaSelecionado[0]?.UF}}, CEP: {{mainContainerService?.ocorrenciaSelecionado[0]?.Cep}}</p>
                          </div>
                        </div>
                        <app-map-saneamento-clie
                          [latAntiga]="mainContainerService?.ocorrenciaSelecionado[0].latitude"  
                          [longAntiga]="mainContainerService?.ocorrenciaSelecionado[0].longitude"
                          [dadosSaneamento]="mainContainerService?.ocorrenciaSelecionado[0].Json"
                        ></app-map-saneamento-clie>
                        <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.Situacao == enumTipoSituacao.Aberto" class="d-flex justify-content-end mt-4">
                            <button class="btn-recusar mr-4" (click)="atualizaSituacao(enumTipoSituacao.Cancelado, tipoOcorrenciaEspecial.SANEAMENTO_CLIENTE)">
                              <img class="mb-1 mr-1" src="assets/imgs/x-cancelar.svg" alt="">
                              Recusar saneamento
                            </button>
                            <button class="btn-aceitar" (click)="atualizaSituacao(enumTipoSituacao.Encerrado, tipoOcorrenciaEspecial.SANEAMENTO_CLIENTE)">
                              <img src="assets/imgs/check.svg" alt="">
                              Aceitar saneamento
                            </button>
                        </div>
                      </div>
                    </div>

                    <!-- Custo Extra -->
                    <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.TipoEspecial == tipoOcorrenciaEspecial.CUSTO_EXTRA && mainContainerService?.ocorrenciaSelecionado[0]?.especial == true" class="msg">
                      <h5 class='nome'> {{  mainContainerService.descricaoMotoAjudante  }}
                        <span class='data'>{{ util.converteData(mainContainerService?.ocorrenciaSelecionado[0]?.Data) | date:'dd/MM/yy | HH:mm'  }}</span>
                      </h5>
                      <div  class="texto">
                        <div class="cliente d-flex">
                          <p class="cliente-endereco mr-1 mb-0">Motivo:</p>
                          <p class="propriedade-cliente mr-5">{{ mainContainerService?.ocorrenciaSelecionado[0].dadosJson.tipoCustoExtra }}</p>

                          <p class="cliente-endereco mr-1 mb-0">Valor:</p>
                          <p class="propriedade-cliente">{{ mainContainerService?.ocorrenciaSelecionado[0].dadosJson.custoExtra | currency: 'BRL'}}</p>
                        </div>
                        <div class="endereco d-flex" *ngIf="this.mainContainerService.ocorrenciaSelecionado[0].msgCustoExtra">
                          <p class="cliente-endereco mr-1">Descrição:</p>
                          <div class="propriedade-cliente d-flex">
                            <p>{{ this.mainContainerService.ocorrenciaSelecionado[0].msgCustoExtra }}</p>
                          </div>
                        </div>                                         
                        <div *ngIf="mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra" class="d-flex justify-content-center "  style="overflow: auto;"   >
                          <img *ngFor="let item of mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra; let i=index" src="{{'data:image/jpg;base64,' + mainContainerService.ocorrenciaSelecionado[0].imagensCustoExtra[i]}}" alt="imagem custo" class="overflow-auto br-custo-extra mr-2">
                        </div>
                       
                        <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.Situacao == enumTipoSituacao.Aberto" class="d-flex justify-content-end mt-4">
                            <button class="btn-recusar mr-4" (click)="atualizaSituacao(enumTipoSituacao.Cancelado, tipoOcorrenciaEspecial.CUSTO_EXTRA )">
                              <img class="mb-1 mr-1" src="assets/imgs/x-cancelar.svg" alt="">
                              Recusar custo
                            </button>
                            <button class="btn-aceitar" (click)="atualizaSituacao(enumTipoSituacao.Encerrado, tipoOcorrenciaEspecial.CUSTO_EXTRA)">
                              <img src="assets/imgs/check.svg" alt="">
                              Aceitar custo
                            </button>
                        </div>
                      </div>
                    </div>

                    <!-- Horario recebimento -->
                    <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.TipoEspecial == tipoOcorrenciaEspecial.HORARIO_RECEBIMENTO && mainContainerService?.ocorrenciaSelecionado[0]?.especial == true" class="msg">
                      <h5 class='nome'> {{  mainContainerService.descricaoMotoAjudante  }}
                        <span class='data'>{{ util.converteData(mainContainerService?.ocorrenciaSelecionado[0]?.Data) | date:'dd/MM/yy | HH:mm'  }}</span>
                      </h5>
                      <div  class="texto">                      
                        <div class="endereco d-flex" *ngIf="this.mainContainerService.ocorrenciaSelecionado[0].msgHorarioRecebimento">
                          <p class="cliente-endereco mr-1">Descrição:</p>
                          <div class="propriedade-cliente d-flex">
                            <p>{{ this.mainContainerService.ocorrenciaSelecionado[0].msgHorarioRecebimento }}</p>
                          </div>
                        </div>       
                        
                        <div class="d-flex flex-column align-items-center">
                          <div *ngFor="let item of mainContainerService?.ocorrenciaSelecionado[0]?.dadosJson.diasSemana" class="mt-2" >                            
                            <app-card-horario-recebimento 
                                [abrevDia]="item.abrevDia" 
                                [recebe]="item.recebe" 
                                [horaDePrimeiro]="mainContainerService?.ocorrenciaSelecionado[0]?.dadosJson.horaDePrimeiro"
                                [horaAtePrimeiro]="mainContainerService?.ocorrenciaSelecionado[0]?.dadosJson.horaAtePrimeiro"
                                [horaDeSegundo]="mainContainerService?.ocorrenciaSelecionado[0]?.dadosJson.horaDeSegundo"
                                [horaAteSegundo]="mainContainerService?.ocorrenciaSelecionado[0]?.dadosJson.horaAteSegundo"
                              ></app-card-horario-recebimento>

                          </div>
                        </div>
                                             
                        <div *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.Situacao == enumTipoSituacao.Aberto" class="d-flex justify-content-end mt-4">
                            <button class="btn-recusar mr-4" (click)="atualizaSituacao(enumTipoSituacao.Cancelado, tipoOcorrenciaEspecial.HORARIO_RECEBIMENTO )">
                              <img class="mb-1 mr-1" src="assets/imgs/x-cancelar.svg" alt="">
                              Recusar
                            </button>
                            <button class="btn-aceitar" (click)="atualizaSituacao(enumTipoSituacao.Encerrado, tipoOcorrenciaEspecial.HORARIO_RECEBIMENTO)">
                              <img src="assets/imgs/check.svg" alt="">
                              Aceitar
                            </button>
                        </div>
                      </div>
                    </div>


                  
                    <div id='box{{i}}' [ngClass]="msg?.IdOrigem == 0 ? 'msg motorista' : 'msg empresa'" *ngFor="let msg of mainContainerService.ocorrenciaSelecionado[0]?.ocorrenciaMsg, let i = index">
                      <h5 class='nome'>{{ msg?.IdOrigem == 0 ? mainContainerService.descricaoMotoAjudante :  msg?.NomeAtendente ? msg?.NomeAtendente : 'Distribuidora' }} 
                        <span class='data'>{{ util.converteData(msg?.Data) | date:'dd/MM/yy | HH:mm'  }} </span>
                      </h5>
                       <div *ngIf="isBase64(msg?.Mensagem); else isNotBase64">                 
                        <img src="{{'data:image/jpg;base64,' + msg?.Mensagem}}" alt="imagem ocorrência">
                      </div> 
                      <ng-template #isNotBase64>
                        <div *ngIf="msg.Storage == 1;else conversa" class='texto d-block'>

                          <p [ngClass]="{'nao-expirou': !msg.expirou, 'expirou-data': msg.expirou }">                     
                            <i class="fa fa-hourglass-2 ml-2 mr-2" *ngIf="!msg.expirou"></i> 
                            <i class="fa fa-hourglass-end  ml-2 mr-2" *ngIf="msg.expirou" ></i>                    
                              Download {{ msg.expirou? 'expirou' : 'expira' }} em {{ msg.dataExpiracao | date: 'dd/MM/yyyy'}} às {{ msg.dataExpiracao | date: 'HH:mm'}}
                          </p>

                          <div class="d-flex justify-content-between">
                            <p style="font-size: 16px;">   
                              <img [src]="msg.Mensagem.tipoArquivo === 'xml' ? 'assets/imgs/icon_xml.svg' : 'assets/imgs/icon_pdf.svg'" alt="icone tipo arquivo" class="mr-2"> 
                              {{ msg.Mensagem.nomeArquivo }}  
                              <span class="mr-3 tamanho-arquivo" >{{ msg.Mensagem.tamanhoArquivo }}KB</span>     
                            </p>
                            <p *ngIf="!msg.expirou">
                               <img *ngIf="msg.Mensagem.tipoArquivo != 'xml'" src="assets/imgs/visualizar_arquivo.svg" (click)="consultaArquivo(msg)" class="mr-3 btn-hover">  
                               <img src="assets/imgs/download_arquivo.svg" (click)="consultaArquivo(msg, true)" class="mr-2 btn-hover" >
                            </p>
                          </div>
                              
                          
                          <p *ngIf="msg.Mensagem.msg" class="sub-titulo-mot-ajud"> Observação: <span class="obs-arquivo ml-1"> {{ msg.Mensagem.msg }} </span> </p>
                        </div>
                        <ng-template #conversa>
                          <div class='texto' [innerHTML]="msg?.Mensagem"></div>
                        </ng-template>                       
                      </ng-template>
                    </div>
                  </section>
                  <footer class="bg-white size-footer" *ngIf="mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 1 || mainContainerService?.ocorrenciaSelecionado[0]?.IdStatus == 2" style="height: 53px;">
                    <input id="msg"  type="text" name="msg" placeholder='Digitar mensagem'>
                    
                    <input type="file"  id="inputFilePDFXML" hidden="true" accept=".pdf,.xml" (change)="selecionaArquivos($event)" multiple>
                    <img src="assets/imgs/clip.svg" class="btn-hover position-clip"  (click)="anexarArquivos()" >
                    <button hidden="true" id="btnMostraArquivos" data-toggle="modal" data-target="#popup-anexa"></button>
                    <button class="btn" (click)="enviarMsg()" [ngClass]="{'p-0': loadingEnvioMsg, 'color-transparente' : loadingEnvioMsg}" [disabled]="loadingEnvioMsg">
                        <img  src="assets/imgs/loading2.gif"   *ngIf="loadingEnvioMsg" class="loading-envio-msg">
                       Enviar
                    </button>
                  </footer>
                </section>
              </div>
        </div>
       
      </div>
    </div>
  </div>
</div>


<!-- Modal anexar imagem -->
<div id="popup-anexa" class="modal fade" tabindex="888" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style="margin-top: 10%;"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" > Anexar arquivos nos formatos .pdf ou .xml  </h5>
        <img data-dismiss="modal" class='bt-fechar' src="assets/imgs/icon_bt-limpar_header.svg" id="btnCloseModalArquivo" (click)="btnFechaModalArquivo()">        
      </div>
      <div class="modal-body p-4">
       
        <div style="max-height: 200px;overflow: auto;">
          <div *ngFor="let arquivo of arquivos; let i=index" class="d-flex justify-content-between mb-2 align-items-baseline">   
            <span class="mr-2" >
              <img [src]="arquivo.type === 'text/xml' ? 'assets/imgs/icon_xml.svg' : 'assets/imgs/icon_pdf.svg'" alt="icone tipo arquivo" class="mr-1">
              <span class="mr-2 nome-arquivo">{{ arquivo.nome }}</span>
              <span class="mr-3 tamanho-arquivo" >{{ (arquivo.size / 1024).toFixed(1) }}KB</span>    
             </span>          
            <i class="fa fa-trash-o btn-hover mr-3" (click)="removeArquivo(arquivo.name)" ></i>
          </div>
        </div>    
        
        <div class="mt-4">
          <span class=" btn-atualizar-mensagem border-none btn-hover" (click)="anexarArquivos()"  >+ Adicionar</span>
        </div>        
       
        <input type="text" class="form-control w-100 mt-3" placeholder="Observação (opcional)" [(ngModel)]="msgArquivo">
        <div class="d-flex justify-content-lg-end mt-3">
          <button  class="btn btn-secondary mr-2" data-dismiss="modal" (click)="fechaAnexaArquivo()" >Cancelar</button>
          <button class="btn btn-success" (click)="enviarArquivos()" [disabled]="!arquivos.length" >Enviar</button>
        </div>
      </div>
    </div>
  </div>
</div>